import { gql } from '@/__generated__';

export const PaymentsDocument = gql(/* GraphQL */ `
  query Payments(
    $where: PaymentWhereInput
    $orderBy: [PaymentOrderByWithRelationInput!]
    $skip: Int
    $take: Int
  ) {
    payments(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
      id
      method
      amount
      referenceId
      status
      createdAt
      updatedAt
      order {
        id
        total
        package
        customer {
          id
          name
        }
      }
      metadata
    }
  }
`);

export const UpdatePaymentDocument = gql(/* GraphQL */ `
  mutation UpdatePayment($where: PaymentWhereUniqueInput!, $data: PaymentUpdateInput!) {
    updatePayment(where: $where, data: $data) {
      id
      method
      amount
      referenceId
      status
      createdAt
      updatedAt
      order {
        id
        total
        package
        customer {
          id
          name
        }
      }
    }
  }
`);

export const DeletePaymentDocument = gql(/* GraphQL */ `
  mutation DeletePayment($where: PaymentWhereUniqueInput!) {
    deletePayment(where: $where) {
      id
    }
  }
`);
